import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import RouteBloc from "../../../bloc/route_bloc";
import Config from "../../../Config";

import "./mrtt_client_screen.css";
import AppLoadingDialog from "../../dialog/app_loading_dialog";
import GeneralBloc from "../../../bloc/general_bloc";

class ClientInvalidLink extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            idNo: null,
            qrExpired: false,
        };
    }

    componentDidMount() {

    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    qrInvalid() {
        return (
            <>
                <div className="d-flex justify-content-center p-4 row w-100 m-0">
                    <img
                        src={
                            GeneralBloc.getAssetsContextPath() +
                            `/assets/images/Illustration/QR_Expired.png`
                        }
                        alt="Documents"
                        className=""
                        style={{ width: 335, height: 187 }}
                    />
                    <div className="client_instruction_text">
                        <div style={{ fontWeight: '600', fontSize: 16 }}>QR Code Invalid</div>
                        <div className="mt-2" >QR Code is invalid. Please contact  your Sales Representative.</div>
                    </div>
                </div>
            </>
        )
    }

    render() {
        return (
            <div className="client_container" style={{ height: '100%' }}>
                <div className="mobile_container justify-content-center" style={{ height: window.innerHeight}}>
                    <div className="client_header">
                        QR Code Invalid
                    </div>
                    {
                            this.qrInvalid() 
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
});

export default withRouter(connect(mapStateToProps)(ClientInvalidLink));
